/* eslint-disable prefer-destructuring */
/**
 * This is our custom theme where we define global styles.
 * It should serve as a guideline for styling, but not all styles *have* to be taken from here.
 */
const breakpoints = ['0px', '600px', '960px', '1280px', '1920px'];

//  Aliases
breakpoints.xs = breakpoints[0];
breakpoints.sm = breakpoints[1];
breakpoints.md = breakpoints[2];
breakpoints.lg = breakpoints[3];
breakpoints.xl = breakpoints[4];

const devices = {
  xs: `only screen and (max-width: ${breakpoints.xs})`,
  sm: `only screen and (max-width: ${breakpoints.sm})`,
  md: `only screen and (max-width: ${breakpoints.md})`,
  lg: `only screen and (max-width: ${breakpoints.lg})`,
  xl: `only screen and (max-width: ${breakpoints.xl})`,
};

/**
 * Primary: Colors to use for actionable items, such as links, buttons etc.
 * Grey: Colors for items that are not that important
 */
const colors = {
  white: '#FFF',
  black: '#000',
  dark: '#191C1F',

  volcanicSand: '#333333',
  swanDown: '#F9F9F9',
  skye: '#4371C7',

  businessGrey: '#666666',
  snowBlind: '#FFFFFF',
  newGrowth: '#5AB372',
  politePink: '#E86372',

  grey: {
    v1: '#F3F4F5',
    v2: '#E5E5E5',
    v3: '#A4ACB4',
    v4: '#8D98A2',
    v5: '#888888',
    v6: '#797979',
    v7: '#333638',
  },

  green: {
    v1: '#07BE67',
  },
};

/**
 * Space is used for margin and padding scales.
 * It's recommended to use powers of two to ensure alignment across the entire project
 */
const space = [
  '0',
  '4px',
  '8px',
  '16px',
  '32px',
  '64px',
  '128px',
  '256px',
  '512px',
];

/**
 * Typographic scale
 */
const fontSizes = [
  '12px',
  '14px',
  '16px',
  '20px',
  '24px',
  '32px',
  '48px',
  '64px',
  '96px',
  '128px',
];

/**
 * Font-Family
 */
const fonts = {
  primary: 'SFProDisplay, sans-serif',
  code: 'Oxygen Mono, monospace',
};

const lineHeights = [1, 1.125, 1.25, 1.5];

const fontWeights = {
  normal: 400,
  semibold: 600,
};

/**
 * Letter-spacing should vary, depending on usage of text
 */
const letterSpacings = {
  normal: 'normal',
  caps: '0.25em',
  labels: '0.05em',
};

/**
 * Border-radius
 */
const radii = ['0', '2px', '4px', '8px', '16px'];

const theme = {
  name: 'Default',
  breakpoints,
  devices,
  colors,
  space,
  fontSizes,
  fonts,
  lineHeights,
  fontWeights,
  letterSpacings,
  radii,
};

export default theme;
